import { type IAudit, type IChecklistNode, findOneById } from '@ifs-gcp/core';

import { syncReportLanguage } from '@/utils/syncReportLanguage';

export function syncChecklistLanguage(audit: IAudit, language: string): void {
  for (const [moduleId, module] of audit.modules.modules.entries()) {
    for (const checklistId of module.checklists.checklists.keys()) {
      const checklistWidget = findOneById<IChecklistNode>(
        audit.templateHandler.schema,
        checklistId,
        moduleId,
      );

      if (!checklistWidget) {
        continue;
      }

      if (!checklistWidget.props.supportLanguage.includes(language)) {
        continue;
      }

      const checklistDomain = audit.factory('checklist', checklistWidget);

      checklistDomain.language = language;
      checklistDomain.dispose();

      syncReportLanguage(audit, checklistWidget.props.context, language);
    }
  }
}
